/*
 * File: CustomOverlapImg.tsx
 * Project: a-a
 * File Created: Wednesday, 23rd April 2025 11:12:09 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 16th September 2025 11:04:34 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */

import { Box, Typography } from '@mui/material';
import style from './CustomOverlapImg.module.css';
import zeplinColor from '../../../theme/Color';

const CustomOverlapImg = ({ images, name }: { images: string[]; name: string[] }) => {
  console.log(images, name);
  return (
    <div className={style.avatars}>
      {images?.map((val, key) =>
        key <= 3 ? (
          val ? (
            <span className={style.avatar} key={key}>
              <img src={val} alt='overlap-icon' />
            </span>
          ) : (
            <Box
              sx={{
                borderRadius: '100px',
                padding: '10px',
                width: '32px',
                height: '32px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor:
                  zeplinColor[
                    key % 8 === 0
                      ? 'Brand1'
                      : (`USER_PROFILE_COLOR${key % 8}` as keyof typeof zeplinColor)
                  ],
              }}
              className={style.avatar}
            >
              <Typography variant='label1' color={zeplinColor.Neutral1}>
                {name[key]
                  ?.split(' ')
                  .map((value: any, index: number) =>
                    name[key] && (index === 0 || index === name[key]?.split(' ').length - 1)
                      ? value[0].toUpperCase()
                      : '',
                  )}
              </Typography>
            </Box>
          )
        ) : (
          ''
        ),
      )}
      {images?.length > 4 && (
        <Box
          sx={{
            borderRadius: '100px',
            padding: '10px',
            width: '32px',
            height: '32px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: zeplinColor.USER_PROFILE_COLOR1,
          }}
          className={style.avatar}
        >
          <Typography variant='label1' color={zeplinColor.Neutral1}>
            +{images?.length - 4}
          </Typography>
        </Box>
      )}
    </div>
  );
};

export default CustomOverlapImg;
